var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form"},[_c('div',{staticClass:"col-12"},[_c(_vm.getMsgCurrentPage,{tag:"component"})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }